import TaskIcon from 'assets/icons/pathway/TaskIcon';
import VideoChatIcon from 'assets/icons/pathway/VideoChatIcon';
import { BodySmall, FlexSm, FlexSmAlignCenter } from 'components/Elements';
import { ActivityType, BuildMethod } from 'models/Activity';
import strings from '../../../strings/strings.json';
import { IconSize } from 'assets/icons/icon-sizes';
import QuestionnaireIcon from 'assets/icons/pathway/QuestionnaireIcon';
import styled from 'styled-components';

type ActivityTypeLabelProps = {
    activityType: ActivityType;
    buildMethod: BuildMethod;
    hideIcon?: boolean;
};

export default function ActivityTypeLabel({
    activityType,
    buildMethod,
    hideIcon,
}: ActivityTypeLabelProps): JSX.Element {
    let labelContents: JSX.Element = <></>;

    if (!activityType) return <></>;

    switch (activityType) {
        case ActivityType.LIVE_TRAINING:
            labelContents = (
                <Label>
                    {!hideIcon && <VideoChatIcon size={IconSize.MEDIUM} />}
                    <BodySmall $nowrap>{strings.activityTypeLabels.liveTraining}</BodySmall>
                </Label>
            );
            break;
        case ActivityType.QUESTIONNAIRE:
            labelContents = (
                <Label>
                    {!hideIcon && <QuestionnaireIcon size={IconSize.MEDIUM} />}
                    <BodySmall $nowrap>{strings.activityTypeLabels.questionnaire}</BodySmall>
                </Label>
            );
            break;
        case ActivityType.TASK:
            const taskType = buildMethod !== BuildMethod.NONE ? getTaskTypeLabel(buildMethod) : '';
            labelContents = (
                <Label>
                    {!hideIcon && <TaskIcon size={IconSize.MEDIUM} />}
                    <BodySmall $nowrap>{`${strings.activityTypeLabels.task} ${taskType}`}</BodySmall>
                </Label>
            );
            break;
        default:
            return <></>;
    }

    return <FlexSmAlignCenter>{labelContents}</FlexSmAlignCenter>;
}

function getTaskTypeLabel(method: BuildMethod): string {
    switch (method) {
        case BuildMethod.AUDIO:
            return strings.courseAIGeneratedContentComponent.taskTypeLabel.audio;
        case BuildMethod.VIDEO:
            return strings.courseAIGeneratedContentComponent.taskTypeLabel.video;
        case BuildMethod.TEXT_AND_IMAGE:
        default:
            return strings.courseAIGeneratedContentComponent.taskTypeLabel.text;
    }
}

const Label = styled(FlexSm)`
    align-items: center;
    white-space: nowrap;
`;
